module.exports = __webpack_public_path__ + "img/Group3.57477f20.svg";